// extracted by mini-css-extract-plugin
export default {"root":"HVAvatar_module-XYSNZOTO_root__oXo81"};